import { render, staticRenderFns } from "./ShowVideo.vue?vue&type=template&id=1ca0a5e7"
import script from "./ShowVideo.vue?vue&type=script&lang=js"
export * from "./ShowVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports